import React, { useState, useEffect, useRef } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import ProgressBar from "react-bootstrap/ProgressBar";
import * as ReactBootstrap from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

// Inside the component

function calculateTotalMarks(marks) {
  if (!marks || marks.length === 0) return 0; // If marks is undefined or empty, return 0
  if (marks.length === 1) return parseInt(marks[0], 10);

  return marks.reduce(
    (total, mark) => total + (mark ? parseInt(mark, 10) : 0),
    0
  );
}
const getProgressColor = (progress) => {
  if (progress <= 30) {
    return "danger";
  } else if (progress <= 60) {
    return "warning";
  } else {
    return "success";
  }
};

const role = localStorage.getItem("userrole");

function ViewEmployeeAppraisal() {
  const [employee, setEmployee] = useState([]);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [subcat, setSubcat] = useState([]);
  const [grade, setGrade] = useState([]);
  const [categoryMapvalues, setCategoryMapvalues] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [approval, setApproval] = useState(null);
  const [appeal, setAppeal] = useState(null);
  const [approvalDate, setApprovalDate] = useState(null);
  const [appeallDate, setAppeallDate] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [employeeComments, setEmployeeComments] = useState(null);
  const [employeeApprovalDate, setEmployeeApprovalDate] = useState(null);
  const [sectionTotal, setSectionTotal] = useState(null);
  const [attsubtotal, setAttSubtotal] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const [categorySubtotal, setCaegorytSubtotal] = useState(0);
  const [primaryCategoryName, setPrimaryCategoryName] = useState("");
  const [formData, setFormData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [showLabel, setShowLabel] = useState(false);
  const [attendanceOptions, setAttendanceOptions] = useState(false);
  const [performanceeOptions, setPerformanceOptions] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState(false);
  const [attendan, setAttendance] = useState(false);
  const [performanceeAnswers, setPerformanceAnswers] = useState(false);
  const [attendanceAnswers, setAttendanceAnswers] = useState(false);
  const [managerName, setManagerName] = useState(false);
  const [supervisorName, setSupervisorName] = useState(false);
  const [hassupervisor, setHasSupervisor] = useState("no");
  const [kpiOptions, setKPIOptions] = useState(false);
  const [kpiTotal, setKPITotal] = useState(0);
  const [totVal, setTotVal] = useState(0);

  const [testOptions, setTestOptions] = useState();

  const [showApprovalButtons, setsShowApprovalButtons] = useState(
    "col-lg-11 text-end mt-4 pb-3"
  );
  const [subkpiOptions, setSubKPIOptions] = useState(false);
  const [trainingComment, setTrainingComment] = useState(null);
  const [generalComments, setGeneralComment] = useState(null);
  const [managerComments, setManagerComments] = useState(null);
  const [approverComments, setApproverComments] = useState(null);
  const [smartKPITotal, setSmartKPITotal] = useState(0);
  const [subKPITotal, setSubKPITotal] = useState(0);
  const [atotal, setAtotal] = useState(null);
  const [ptotal, setPtotal] = useState(null);
  const [cattotal, setCatTotal] = useState(null);
  const [employeeStatus, setEmployeeStatus] = useState(null);

  const [total, setTotal] = useState(0);
  // ▶ URLSearchParams {}
  const userid = localStorage.getItem("userid");
  const [posts, setPosts] = useState({ smartgoals: [] });
  const [expandedRow, setExpandedRow] = useState(null);
  const [postsSub, setPostsSub] = useState({ subgoals: [] });
  const [isKpiWeightageIncluded, setIsKpiWeightageIncluded] = useState(false);
  const [KPIWeightage, setKPIWeightage] = useState(0);
  const [apprQuestionsWeightage, setApprQuestionsWeightage] = useState(0);
  let deptid = localStorage.getItem("departmentid");
  let currentuserid = localStorage.getItem("employeeid");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const appraisalmonth = searchParams.get("mon");
  const appraisalyear = searchParams.get("yr");
  const period = searchParams.get("periods");
  const index = [...period]?.findIndex((char) => !isNaN(char));
  const month = period?.slice(0, index);
  const year = period?.slice(index);
  const [appealStatus, setAppealStatus] = useState(null);
  const [showHRApproval, setShowHRApproval] = useState(null);
  const [hrApproved, setHRApproved] = useState(false);
  const [hrComments, setHRComments] = useState(null);
  const [apraisalid, setAppraiaisalId] = useState(null);
  const [datemanagerapproved, setDateManagerApproved] = useState(null);
  const [approvalcomments, setApprovalComments] = useState(null);
  const [rating, setRating] = useState(null);
  const [approversComments, setApproversComments] = useState(null);
  const [assessorComments, setAssessorComments] = useState(null);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [assessorDate, setAssessorDate] = useState(null);
  const [approversDate, setApproversDate] = useState(null);
  const id = searchParams.get("id");
  const action = searchParams.get("action");
  const appraisalid = searchParams.get("aid");
  const readonly = searchParams.get("r");
  const [perfmarks, setPefMarks] = useState(
    Array(performanceeOptions.length).fill("")
  );
  const [catSubtotal, setCatSubtotal] = useState(null);
  const [categorymarks, setCategorymarks] = useState({});
  const [catSubcatMarks, setCatSubcatMarks] = useState({});
  const [subcategoryNames, setSubcategoryNames] = useState({});
  const [isEditingMarks, setIsEditingMarks] = useState(false);
  const [updatedMarks, setUpdatedMarks] = useState({});

  const [initialValues, setInitialValues] = useState({});
  const [form2Data, setForm2Data] = useState({
    appealcomments: "",
    userid: id,
    // Add other fields here
  });
  const handleAppealChange = (event) => {
    const { name, value } = event.target;
    setForm2Data({
      ...form2Data,
      [name]: value,
    });
  };

  // const match = period?.match(/([a-zA-Z]+)(\d+)/);
  // const match = period?.split("%20");

  // const text = match[1];
  // const number = match[2];

  const handleConfirm = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/approvaeappraisal?id=` + id + "&status=Approved",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setFormData(null);
        setIsModalOpen(false);
        addNotification();
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/dashboard");
        }, 3000);

        // window.location.href = "/dashboard";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleHRApproval = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/hrapproval?id=` +
          id +
          "&aid=" +
          appraisalid +
          "&c=" +
          hrComments +
          "&period=" +
          period
      );
      const data = response.data;
      if (response.status === 200) {
        setHRApproved(true);
        setApprovalStatus("HR Approved");
        navigate("/listappraisal");
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const addNotification = async (id) => {
    try {
      const response = await axios.get(
        `${baseURL}/addnotification?id=` + userid
      );
      const data = response.data;
      if (response.status === 200) {
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleConfirmAppeal = async () => {
    try {
      const form2DataWithAid = {
        ...form2Data, // Copying existing form2Data
        aid: apraisalid, // Adding the aid variable
      };
      const response = await axios.post(
        `${baseURL}/appealrequest`,
        {
          form2DataWithAid,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status) {
        setFormData(null);
        setIsModalOpen(false);

        window.location.href = "/dashboard";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleSubmit = async (values) => {
    const questionsWithValues = values.questions?.map((question, index) => ({
      ...question,
      question: options[index].text,

      // Add the question text from options
    }));
    const perfquestionsWithValues = values.questions?.map(
      (questionsp, index) => ({
        ...questionsp,
        question: performanceeOptions[index].text,

        // Add the question text from options
      })
    );

    const categoryquestionsWithValues = values.questionsx?.map(
      (questionsx, idx) => ({
        ...questionsx,
        question: categoryOptions[idx].text,
        // question: options[index].text,
        category: categoryOptions[idx].category,
        subcategory: categoryOptions[idx].subcategory,
        rating: categoryOptions[idx].rating,
        marks: categorymarks[idx],
        // Add the question text from options
      })
    );
    const formData = {
      employeeid: id,
      questions: questionsWithValues,
      questionsp: perfquestionsWithValues,
      questionsx: categoryquestionsWithValues,
    };
    setFormData(formData);
    setIsModalOpen(true);
  };
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const handleHEmployeeomments = (e) => {
    let val = e.target.value;
    setEmployeeComments(val);
  };
  const handleApproveromments = (e) => {
    let val = e.target.value;
    setApproverComments(val);
  };
  const handleApproverSubmit = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/addapprovercomments?id=` +
          id +
          "&aid=" +
          apraisalid +
          "&cmt=" +
          approverComments +
          "&period=" +
          period
      );
      const data = response.data;
      alert("Approver approval submitted");
      // window.location.href = "/myteamappraisal";
      navigate("/myteamappraisal");
    } catch (err) {
      console.error("Error :", err);
    }
  };

  const handleApproverRejectSubmit = async () => {
    try {
      if (!apraisalid) {
        alert("Missing appraisal ID");
        return;
      }

      /** --------------------------------------------------
       * STEP 1 — Build cleared marks + empty comments
       * -------------------------------------------------- */
      const clearedQuestionsObject = {};

      catSubcatMarks.forEach((item) => {
        const key = `questions${item.category}`;

        if (!clearedQuestionsObject[key]) {
          clearedQuestionsObject[key] = [];
        }

        clearedQuestionsObject[key].push({
          category: item.category,
          subcategory: item.subcategory,
          question: item.question,
          marks: 0,
          comments: "",
        });
      });

      /** --------------------------------------------------
       * STEP 2 — Load original JSON from server
       * -------------------------------------------------- */
      const resp = await axios.get(
        `${baseURL}/getmyappraisal?employeeid=${id}`
      );

      const original = JSON.parse(resp.data.appraisaldata[0].questions);

      /** --------------------------------------------------
       * STEP 3 — Merge only marks & comments into original
       * -------------------------------------------------- */
      const merged = { ...original };

      Object.keys(original).forEach((key) => {
        if (key.startsWith("questions") && Array.isArray(original[key])) {
          const clearedItems = clearedQuestionsObject[key];

          if (clearedItems) {
            original[key].forEach((q) => {
              const found = clearedItems.find(
                (u) =>
                  u.category === q.category &&
                  u.subcategory === q.subcategory &&
                  u.question === q.question
              );

              if (found) {
                q.marks = 0;
                q.comments = "";
              }
            });

            merged[key] = original[key];
          }
        }
      });

      /** --------------------------------------------------
       * STEP 4 — Save cleared marks & comments
       * -------------------------------------------------- */
      await axios.post(
        `${baseURL}/updateappraisalmarks`,
        {
          appraisalid: apraisalid,
          questions: merged,
          trainingcomments: trainingComment,
          assessorcomments: assessorComments,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      /** --------------------------------------------------
       * STEP 5 — DELETE all old status rows for this appraisal
       * -------------------------------------------------- */
      await axios.post(`${baseURL}/deleteAppraisalStatusByAppraisalId`, {
        appraisalid: apraisalid,
      });

      /** --------------------------------------------------
       * STEP 6 — Insert fresh Approver Rejected status
       * -------------------------------------------------- */
      // await axios.post(`${baseURL}/approverRejectStatus`, {
      //   employeeid: id,
      //   appraisalid: apraisalid,
      //   comments: approverComments || "",
      // });

      /** --------------------------------------------------
       * STEP 7 — Notify user
       * -------------------------------------------------- */
      alert("Rejected successfully. Marks cleared & status updated.");
      window.location.href = "/myteamappraisal";
    } catch (err) {
      console.error("Error Reject:", err);
      alert("Reject failed.");
    }
  };

  const handleCommentChange = (
    categoryName,
    subcategory,
    question,
    newComment
  ) => {
    const key = `${categoryName}_${subcategory}_${question}`;

    setUpdatedMarks((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        category: categoryName,
        subcategory: subcategory,
        question: question,
        comments: newComment,
      },
    }));

    setCatSubcatMarks((prev) => {
      return prev.map((item) => {
        if (
          item.category === categoryName &&
          item.subcategory === subcategory &&
          item.question === question
        ) {
          return { ...item, comments: newComment };
        }
        return item;
      });
    });
  };

  const handleMarkChange = (categoryName, subcategory, question, newMark) => {
    const key = `${categoryName}_${subcategory}_${question}`;
    const newMarkValue = parseInt(newMark) || 0;
    console.log("newmarkvalue", newMarkValue);

    setUpdatedMarks((prev) => ({
      ...prev,
      [key]: {
        category: categoryName,
        subcategory: subcategory,
        question: question,
        marks: newMarkValue,
      },
    }));

    // Update local state for immediate UI feedback
    setCatSubcatMarks((prev) => {
      console.log("set 1", prev);
      const updated = prev.map((item) => {
        if (
          item.category === categoryName &&
          item.subcategory === subcategory &&
          item.question === question
        ) {
          const oldMark = item.marks || 0;
          // Update category totals
          setCategorymarks((prevCat) => ({
            ...prevCat,
            [categoryName]:
              (prevCat[categoryName] || 0) - oldMark + newMarkValue,
          }));
          return { ...item, marks: newMarkValue };
        }
        return item;
      });
      return updated;
    });
  };

  const handleSaveMarks = async () => {
    try {
      if (!apraisalid) {
        alert("Appraisal ID is missing. Cannot save marks.");
        return;
      }

      console.log("Saving updated marks + comments...");
      console.log("catSubcatMarks:", catSubcatMarks);

      /** ---------------------------------------------------------
       * STEP 1 — BUILD UPDATED questionsObject FROM LOCAL STATE
       * --------------------------------------------------------- */
      const updatedQuestionsObject = {};

      catSubcatMarks.forEach((item) => {
        const categoryKey = `questions${item.category}`;

        if (!updatedQuestionsObject[categoryKey]) {
          updatedQuestionsObject[categoryKey] = [];
        }

        updatedQuestionsObject[categoryKey].push({
          category: item.category,
          subcategory: item.subcategory,
          question: item.question,
          marks: item.marks || 0,
          comments: item.comments || "",
        });
      });

      /** ---------------------------------------------------------
       * STEP 2 — GET ORIGINAL QUESTIONS FROM SERVER
       * --------------------------------------------------------- */
      const response = await axios.get(
        `${baseURL}/getmyappraisal?employeeid=` + id
      );

      if (!response.data?.appraisaldata?.[0]) {
        alert("Error: Original appraisal data missing.");
        return;
      }

      const original = JSON.parse(response.data.appraisaldata[0].questions);
      console.log("Original Questions", original);

      /** ---------------------------------------------------------
       * STEP 3 — MERGE UPDATED MARKS + COMMENTS INTO ORIGINAL
       * --------------------------------------------------------- */
      const merged = { ...original };

      Object.keys(original).forEach((key) => {
        if (key.startsWith("questions") && Array.isArray(original[key])) {
          // If this key was updated, merge
          if (updatedQuestionsObject[key]) {
            original[key].forEach((origItem, idx) => {
              const updatedItem = updatedQuestionsObject[key].find(
                (u) =>
                  u.category === origItem.category &&
                  u.subcategory === origItem.subcategory &&
                  u.question === origItem.question
              );

              if (updatedItem) {
                // Update both marks + comments
                origItem.marks = updatedItem.marks;
                origItem.comments = updatedItem.comments;
              }
            });

            merged[key] = original[key];
          }
        } else {
          // preserve other fields: { employeeid, smarkkpi, subkpi, totalmarks }
          merged[key] = original[key];
        }
      });

      /** ---------------------------------------------------------
       * STEP 4 — SEND FINAL MERGED DATA TO SERVER
       * --------------------------------------------------------- */
      const saveResponse = await axios.post(
        `${baseURL}/updateappraisalmarks`,
        {
          appraisalid: apraisalid,
          questions: merged,
          trainingcomments: trainingComment ?? "",
          assessorcomments: assessorComments ?? ""
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      /** ---------------------------------------------------------
       * STEP 5 — SUCCESS UI LOGIC
       * --------------------------------------------------------- */
      if (saveResponse.status === 200) {
        setShowToast(true);
        setIsEditingMarks(false);
        setUpdatedMarks({});

        await fetchEmployeeAppraisal();

        setTimeout(() => {
          setShowToast(false);
        }, 2500);
      }
    } catch (err) {
      console.error("Error saving marks:", err);
      alert("Error saving marks. Please try again.");
    }
  };

  const fetchSubcategoryName = async (subcategoryId) => {
    try {
      const response = await axios.get(
        `${baseURL}/getsubcategorydetails?id=` + subcategoryId
      );
      if (
        response.data &&
        response.data.subcategory &&
        response.data.subcategory.length > 0
      ) {
        return response.data.subcategory[0].subcategoryname;
      }
      return null;
    } catch (err) {
      console.error("Error fetching subcategory name:", err);
      return null;
    }
  };

  useEffect(() => {
    if (options && Object.keys(options).length > 0) {
      fetchEmployeeAppraisal();
    }
  }, [options]);

  const fetchAppraisalTemplate = async (gradeid) => {
    try {
      const response = await axios.get(
        `${baseURL}/gettemplateforappraisa?id=` + gradeid
      );
      const data = response.data;
      if (Array.isArray(data.template)) {
        const { data } = response; // make sure we can get data
        let toJSON = data.template[0].questionsJSON;
        let finaljson = JSON.parse(toJSON);
        console.log("final json", finaljson);
        const questions = finaljson.questions;
        setTestOptions(questions);
        console.log("seted questions", testOptions);

        // Group questions by category and normalize fields
        const groupedQuestions = {};

        questions.forEach((item) => {
          console.log("item", item);
          const categoryId = item.category; // example: "58"
          const key = `questions${categoryId}`; // example: "questions58"

          if (!groupedQuestions[key]) {
            groupedQuestions[key] = [];
          }

          groupedQuestions[key].push({
            category: item.category,
            subcategory: item.subcategory,
            question: item.text || "",
            rating: item.rating,
            marks: item.marks ?? "0",
            comments: item.comments ?? "",
          });
        });

        setOptions(groupedQuestions);
        console.log("options set", options);

        // setOptions(finaljson.questions);
        console.log("wightage", finaljson?.questionsweigtage);
        setApprQuestionsWeightage(finaljson?.questionsweigtage);
        const isKpiEnabled = finaljson?.isKpiWeightageIncluded === true;

        if (isKpiEnabled) {
          console.log("KPI Weightage Included:", isKpiEnabled);

          // Get KPI weightage value from template JSON
          const kpival = finaljson?.kpiweightage || 0;
          console.log("KPI Weightage Value:", kpival);

          // Save value to state
          setKPIWeightage(kpival);
          setIsKpiWeightageIncluded(true);
        } else {
          console.log("KPI Weightage NOT Included");
          setIsKpiWeightageIncluded(false);
        }

        // const category44Options = finaljson.questions.filter(option => option.category === "44");
        // setAttendanceOptions(category44Options);
        // const categoryName = category44Options.length > 0 ? category44Options[0].categoryname : null; // Get category name if available
        // setPrimaryCategoryName(categoryName);
        // const category45Options = finaljson.questions.filter(option => option.category === "45");
        // setPerformanceOptions(category45Options);
        // setTotalQuestions(category44Options.length);

        //const categoryMap = new Map();
        // finaljson.questions.forEach((option) => {
        //     if (!categoryMap.has(option.category)) {
        //         categoryMap.set(option.category, []);
        //     }
        //     categoryMap.get(option.category).push(option);
        // });
        //   setCategoryMapvalues(categoryOtherOptions);
        // console.log(categoryOtherOptions);
        // setSubcat(finaljson[0].subCategoryQuestions);
        //calculateSectionTotals(category45Options);
        const groupedOptions = {};
        const subcategoryIdsToFetch = new Set();

        finaljson.questions.forEach((option) => {
          const categoryName = option.category;
          // if((categoryName!=="44" && categoryName!=="45"))
          if (!groupedOptions[categoryName]) {
            groupedOptions[categoryName] = [option];
          } else {
            groupedOptions[categoryName].push(option);
          }

          // Check if subcategoryname is missing and subcategory ID exists
          if (!option.subcategoryname && option.subcategory) {
            subcategoryIdsToFetch.add(option.subcategory);
          }
        });

        setCategoryMapvalues(groupedOptions);

        // Fetch missing subcategory names
        if (subcategoryIdsToFetch.size > 0) {
          const fetchPromises = Array.from(subcategoryIdsToFetch).map(
            async (subcatId) => {
              const name = await fetchSubcategoryName(subcatId);
              return { id: subcatId, name };
            }
          );

          const fetchedNames = await Promise.all(fetchPromises);
          const namesMap = {};
          fetchedNames.forEach(({ id, name }) => {
            if (name) {
              namesMap[id] = name;
            }
          });

          setSubcategoryNames((prev) => ({ ...prev, ...namesMap }));
        }
        // updateinitVals(groupedOptions)
        //const category44Options = finaljson.questions.filter(option => option.category === "44");
        // setAttendanceOptions(category44Options);
        // const category45Options = finaljson.questions.filter(option => option.category === "45");
        // setPerformanceOptions(category45Options);
        // const categoryOtherOptions = finaljson.questions.filter(option => option.category !== "44" && option.category !== "45");

        //const categoryMap = new Map();
        //  finaljson.questions.forEach((option) => {
        // if (!categoryMap.has(option.category)) {
        //    categoryMap.set(option.category, []);
        // }
        //  categoryMap.get(option.category).push(option);
        // });
        //   setCategoryMapvalues(categoryOtherOptions);
        // console.log(categoryOtherOptions);
        // setSubcat(finaljson[0].subCategoryQuestions);
        // calculateSectionTotals(category45Options);
        // const groupedOptions = {};
        // finaljson.questions.forEach(option => {
        //     const categoryName = option.category;
        //     if((categoryName!=="44" && categoryName!=="45"))
        //         if (!groupedOptions[categoryName] ) {
        //             groupedOptions[categoryName] = [option];
        //         } else {
        //             groupedOptions[categoryName].push(option);
        //         }
        // });
        // setCategoryMapvalues(groupedOptions);
        // updateinitVals(groupedOptions)
      }
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  useEffect(() => {
    const fetchAppealStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getappealrequest?id=` + id
        );
        const data = response.data;
        let appeal = data.appealdata;
        let appealdate = appeal[0].appealdate;
        //
        let appealid = appeal[0].id;

        let appealstatus = appeal[0].status;
        if (appealdate != null) {
          const res = await axios.get(
            `${baseURL}/getappealcommmiteedecisoin?aid=` + appealid
          );
          let appealdataarr = res.data.appealdecision;
          let appealdescision = appealdataarr[0].approval_status;

          let dateformated = formatDate(appealdate);
          setAppeallDate(dateformated);
          if (appealdescision === "Approved") {
            setAppeal("Appealed");
          }
          setAppealStatus(appealdescision);
        }
      } catch (err) {
        console.error("Error fetching appealdata:", err);
      }
    };
    fetchAppealStatus();
  }, []);
  const updateinitVals = (categoryOptions) => {
    let updatedInitialValues = { ...initialValues };

    categoryOptions.forEach((category) => {
      updatedInitialValues[`questions${category.categoryname}`] =
        category.questions?.map((question, qIndex) => ({
          [`questions${category.categoryname}[${qIndex}].question`]:
            question.text || "",
          [`questions${category.categoryname}[${qIndex}].yesno`]: "",
          [`questions${category.categoryname}[${qIndex}].rating`]:
            question.rating || 0,
          [`questions${category.categoryname}[${qIndex}].marks`]: 0,
          [`questions${category.categoryname}[${qIndex}].comments`]: "",
        }));

      setInitialValues(updatedInitialValues);
    });
  };
  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeemaindetails?uid=` + id
        );
        const data = response.data;
        let arrEmployee = data.employee;
        setEmployee(arrEmployee[0]);
        let gradeid = arrEmployee[0].gradeid;
        setGrade(gradeid);
        getKPIForuser(arrEmployee[0].employeeid);
        getSubKPI(arrEmployee[0].employeeid);
        fetchAppraisalTemplate(gradeid);
        let issupervisorPreent = arrEmployee[0].has_supervisor;
        setHasSupervisor(arrEmployee[0].has_supervisor);
        if (issupervisorPreent == "Yes") {
          let supervisorsname =
            arrEmployee[0].SupervisorFirstName +
            " " +
            arrEmployee[0].SupervisorLastName;
          setSupervisorName(supervisorsname);
        }
        let managersname =
          arrEmployee[0].ManagerFirstName +
          " " +
          arrEmployee[0].ManagerLastName;
        setManagerName(managersname);
        //fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeData();
  }, [period]);

  useEffect(() => {
    const fetchManagerComments = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getappraisalmanagercomments?apprid=` + appraisalid
        );
        const data = response.data;
        let commentsArr = data.generalcomments[0];
        let comment = commentsArr.comments;
        setGeneralComment(comment);
        //fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchManagerComments();
  }, []);
  useEffect(() => {
    const fetchEmployeeApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeerapproval?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          const currentEmployeeStatus = appr.status;
          setEmployeeStatus(currentEmployeeStatus);

          if (appr !== undefined) {
            setEmployeeComments(appr.comments);
            setEmployeeApprovalDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchEmployeeStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getappraisalstatus?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appraisaldata[0];
          if (appr !== undefined) {
            let status = appr.status;
            let comment = appr.comments;

            setGeneralComment(comment);

            let asssordate = formatDate(appr.statusdate);
            setAssessorComments(comment);
            setAssessorDate(asssordate);

            // setGeneralComment(gencomment);
            let dateformated;
            setApproval(status);
            if (status === "HR Approved") {
              setHRApproved(true);
              setApprovalStatus(status);
              setHRComments(comment);
            }
            if (appr.statusdate != null) {
              let dateformated = formatDate(appr.statusdate);
              let approvalstatus = appr.status;
              setApprovalDate(dateformated);
              setApprovalStatus(approvalstatus);
              let approvalcomments = appr.comments;
              setApprovalComments(approvalcomments);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeStatus();
    fetchEmployeeAppraisal();
    //   fetchEmployeeAppraisal();
  }, []);

  const calTotalMarks = (questions) => {
    let totalMarks = 0;
    questions.forEach((question) => {
      totalMarks += parseInt(question.marks || 0);
    });

    return totalMarks;
  };
  const handleHRComments = (e) => {
    let val = e.target.value;
    setHRComments(val);
  };

  const handleTextareaChange = (e) => {
    let val = e.target.value;
    setTrainingComment(val);
  };
  const handleKPIChange = (e, smartgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: smartgoalId,
      val: newValue,
    };

    setKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === smartgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;

        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };
  const handleSubKPIChange = (e, subgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: subgoalId,
      val: newValue,
    };

    setSubKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === subgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;
        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };
  const getSubKPI = async (empid) => {
    try {
      const { data } = await axios(`${baseURL}/getsubKPI?eid=` + empid);
      if (Array.isArray(data.subgoals)) {
        setPostsSub({ subgoals: data.subgoals });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  const getKPIForuser = async (empid) => {
    try {
      //alert(empid);
      //  let  strAPI  = "http://localhost:3050/smartgoalsfordepartment?assignee="+empid;
      const strAPI =
        `${baseURL}/getkpiforappraisalperiod?assignee=` +
        empid +
        "&mon=" +
        month +
        "&year=" +
        year;

      const { data } = await axios.get(strAPI);
      setPosts({ smartgoals: data.smartgoals });
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  useEffect(() => {
    const fetchManagerApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getmanagerapproval?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setManagerComments(appr.comments);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchManagerApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchHRApprovaStatus = async () => {
      try {
        const response = await axios.get(`${baseURL}/gethrapproval?id=` + id);
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setHRApproved(true);
            setShowHRApproval(true);
            setHRComments(appr.comments);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchHRApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchAssessorStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getassessorstatus?apprid=` + appraisalid
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appdata[0];
          if (appr !== undefined) {
            setAssessorComments(appr.comments);
            setAssessorDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchAssessorStatus();
  }, []);
  useEffect(() => {
    const fetchApproverStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getapproverstatus?id=` + id
        );
        const data = response.data;
        if (response.status == 200) {
          let appr = data.appealdata[0];
          if (appr != undefined) {
            setApproversComments(appr.comments);
            setApproversDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchApproverStatus();
  }, []);

  function hasQuestionData(obj) {
    if (!obj || typeof obj !== "object") return false;
    return Object.keys(obj).some((key) => key.startsWith("questions"));
  }

  const fetchEmployeeAppraisal = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/getmyappraisal?employeeid=` + id
      );

      const data = response.data;
      let arrEmployee = data.appraisaldata;
      let arrqns = arrEmployee[0]?.questions;

      console.log("arrqns received", arrqns);

      let training = arrEmployee[0].trainingcomments;
      setAppraiaisalId(arrEmployee[0].id);

      let parsedArrqns = arrqns;

      // 1. Parse when it is string JSON
      if (typeof arrqns === "string" && arrqns.trim() !== "") {
        try {
          parsedArrqns = JSON.parse(arrqns);
        } catch (err) {
          parsedArrqns = null;
        }
      }

      // 2. If arrqns is null, undefined, empty object → treat as no questions
      const noQns =
        !parsedArrqns ||
        typeof parsedArrqns !== "object" ||
        !hasQuestionData(parsedArrqns);

      // 3. FINAL JSON
      let finaljson = noQns ? options : parsedArrqns;

      console.log("finaljson used →", finaljson);

      // Continue with existing code:
      setTrainingComment(training);

      let catsums = calculateCategorySums(finaljson);
      let catssubcats = getCatSubcats(finaljson);

      setCategorymarks(catsums);
      setCatSubcatMarks(catssubcats);

      let totalSum = Object.values(catsums).reduce(
        (sum, v) => sum + (parseFloat(v) || 0),
        0
      );
      setTotVal(totalSum);

      let sumkpi = setKPITotals(finaljson);
      setKPITotal(sumkpi);

      let totalval = sumkpi ? totalSum + sumkpi : totalSum;

      switch (true) {
        case totalval >= 95:
          setRating("5-Outstanding");
          break;
        case totalval >= 80:
          setRating("4-Excellent");
          break;
        case totalval >= 65:
          setRating("3-Good");
          break;
        case totalval >= 50:
          setRating("2-Satisfactory");
          break;
        default:
          setRating("1-Unsatisfactory");
      }

      setShowHRApproval(action === "hr");

      setKPIOptions(finaljson.smarkkpi || []);
      setSubKPIOptions(finaljson.subkpi || []);
      setKPITotals(finaljson);

      const dt = formatDate(new Date());
      setDateManagerApproved(dt);
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  const calculateCategorySums = (appriasailjson) => {
    const categorySum = {};

    // Iterate over each top-level key in the data object
    Object.keys(appriasailjson).forEach((key) => {
      const items = appriasailjson[key];

      // Only process if the item is an array (and contains question objects with "marks")
      if (Array.isArray(items)) {
        items.forEach((item) => {
          // Check if 'category' and 'marks' fields are present in the object
          if (item.category && item.marks) {
            const category = item.category;
            const marks = parseInt(item.marks, 10); // Convert to number if needed
            if (!isNaN(marks)) {
              // Add marks to the corresponding category
              categorySum[category] = (categorySum[category] || 0) + marks;
            }
          }
        });
      }
    });

    return categorySum;
  };
  const setKPITotals = (json) => {
    let kpiSum = 0;
    let subKpiSum = 0;
    try {
      kpiSum = json.smarkkpi.reduce((sum, kpi) => sum + (kpi.val || 0), 0);
    } catch (e) {
      //if top level kpi is not there in json
    }
    try {
      subKpiSum = json.subkpi.reduce((sum, kpi) => sum + (kpi.val || 0), 0);
    } catch (e) {
      //if sub  kpi is not there in json
    }
    setKPITotal(kpiSum + subKpiSum);
    return kpiSum + subKpiSum;
  };

  const sumMarksByCategory = (finaljson) => {
    const initialCatmarks = {};

    // Get all question arrays dynamically
    const questionKeys = Object.keys(finaljson).filter((key) =>
      key.startsWith("questions")
    );

    // Loop through each question type
    questionKeys.forEach((key) => {
      const questionsArray = finaljson[key]; // Directly access the questions array

      questionsArray?.forEach((option) => {
        let categoryName = option?.category;
        let marks = option?.marks;
        if (option?.marks === undefined || option?.marks == null) {
          marks = 0;
        } else {
          marks = parseInt(marks);
        }
        if (categoryName) {
          // If this category is encountered for the first time, initialize it with 0
          initialCatmarks[categoryName] =
            (initialCatmarks[categoryName] || 0) + (marks || 0);
        } else {
          console.warn("Missing category or marks in option:", option);
        }
      });
    });

    return initialCatmarks; // Return the accumulated category marks
  };
  useEffect(() => {
    setInitialValues({
      questions: attendanceOptions,
      questionps: performanceeOptions,
    });
  }, [options]);
  useEffect(() => {
    const fetchAssessorStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getassessorstatus?apprid=` + appraisalid
        );
        const data = response.data;
        if (response.status == 200) {
          let appr = data.appdata[0];
          if (appr != undefined || appr != null) {
            setAssessorComments(appr.comments);
            setAssessorDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchAssessorStatus();
  }, []);
  useEffect(() => {
    const fetchSupervisorApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getsupervisorapproval?id=` + id
        );
        const data = response.data;
        if (response.status == 200) {
          let appr = data.appealdata[0];
          if (appr != undefined) {
            setAssessorComments(appr.comments);
            setAssessorDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchSupervisorApprovaStatus();
  }, []);
  const calculateCategorySubtotals = (questions) => {
    return questions?.reduce(
      (sum, question) => sum + (parseInt(question?.marks, 10) || 0),
      0
    );
  };

  const getCatSubTotal = (catjson, categoryval) => {
    // Initialize sum to 0
    let sum = 0;

    // Ensure catjson is an array and iterate over it
    if (Array.isArray(catjson)) {
      catjson.forEach((item) => {
        // Check for category and marks in each item
        if (item.category && item.marks) {
          const category = item.category;
          const marks = parseInt(item.marks, 10); // Convert to a number

          // Add marks to sum if category matches categoryval
          if (!isNaN(marks) && category === categoryval) {
            sum += marks;
          }
        }
      });
    }

    // Return the computed sum
    console.log("SUM==" + sum);
    return sum;
  };

  const getCatSubcats = (appraisalJson) => {
    const categoryDetails = [];

    // Iterate over each top-level key in the data object
    Object.keys(appraisalJson).forEach((key) => {
      const items = appraisalJson[key];
      console.log("items", items);

      // Only process if the item is an array (and contains question objects with "marks")
      if (Array.isArray(items)) {
        items.forEach((item) => {
          // console.log("map item", item);
          // Check if 'category' and 'marks' fields are present in the object
          if (item.category) {
            console.log("come item", item);
            const category = item.category;
            const question = item.question;
            const subcategory = item.subcategory || ""; // Use an empty string if no subcategory is present
            const marks = parseInt(item.marks, 10) || 0; // Convert to number if needed
            const comments = item.comments;
            if (!isNaN(marks)) {
              // Add object with category, subcategory, and marks to array
              categoryDetails.push({
                category,
                subcategory,
                question,
                marks,
                comments,
              });
            }
          }
        });
      }
    });
    console.log("categoryDetails", categoryDetails);

    return categoryDetails;
  };

  const getMarks = (
    categoryDetails,
    targetCategory,
    targetSubcategory,
    question
  ) => {
    // console.log("catsucatmarks", catSubcatMarks);
    // Find the matching item in categoryDetails
    const matchingItem = catSubcatMarks?.find(
      (item) =>
        item.category === targetCategory &&
        item.subcategory === targetSubcategory &&
        item.question === question
    );

    // Return the marks if a matching item is found; otherwise, return null or 0
    return matchingItem ? matchingItem.marks : null;
  };
  const getComments = (
    categoryDetails,
    targetCategory,
    targetSubcategory,
    question
  ) => {
    // Find the matching item in categoryDetails
    const matchingItem = catSubcatMarks?.find(
      (item) =>
        item.category === targetCategory &&
        item.subcategory === targetSubcategory &&
        item.question === question
    );

    // Return the marks if a matching item is found; otherwise, return null or 0
    return matchingItem ? matchingItem.comments : null;
  };
  const calcAllTotal = (values) => {
    let val =
      calculateTotalMarks(values.questionsx?.map((q) => q.marks)) +
      categorySubtotal;
    setTotVal(val);
    return val;
  };
  const getSum = () => {
    const totalSum = (Array.isArray(categorymarks) ? categorymarks : []).reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return totalSum;
  };
  if (approval != null)
    return (
      <>
        <Dummylayout />
        <BasicCard>
          <div className="container topmiller ">
            <div className="row ">
              <h5
                onClick={() => {
                  console.log("CatSubcatMarks", catSubcatMarks);
                }}
              >
                Appraisal of{" "}
              </h5>
              <br />
              <br />
              <div className="col-4 ">
                <span className="vfont fs-">Name</span>
                <p className="bfont fs-5 fw-bold">
                  {employee.FirstName} {employee.LastName}
                </p>
                <span className="vfont fs">Current Position</span>
                <p className="bfont fs-5 fw-bold">{employee.designation}</p>
              </div>
              <div className="col-4 ">
                <span className="vfont fs">Employee ID</span>
                <p className="bfont fs-5 fw-bold"> {employee.employeeid}</p>
                <span className="vfont fs">Grade</span>
                <p className="bfont fs-5 fw-bold">{employee.gradename}</p>
              </div>
              <div className="col-lg-4 ">
                <img
                  className="float-end mx-5"
                  width="110"
                  alt=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                />
              </div>
            </div>
          </div>

          <h5>Appraisal Questions </h5>
          <h6>Appraisal Questions Weightage Value: {apprQuestionsWeightage}</h6>

          {(role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") &&
            employeeStatus !== "Employee Accepted" && (
              <div className="d-flex justify-content-end">
                {!isEditingMarks && readonly !== "1" && (
                  <div className="mb-3">
                    <Button
                      variant="primary"
                      onClick={() => setIsEditingMarks(true)}
                      className="mb-2"
                    >
                      Edit
                    </Button>
                  </div>
                )}

                {isEditingMarks && (
                  <div className="mb-3">
                    <Button
                      variant="success"
                      onClick={handleSaveMarks}
                      className="mb-2 me-2"
                    >
                      Save
                    </Button>

                    <Button
                      variant="secondary"
                      onClick={() => {
                        setIsEditingMarks(false);
                        setUpdatedMarks({});
                        fetchEmployeeAppraisal();
                      }}
                      className="mb-2"
                    >
                      Cancel
                    </Button>
                  </div>
                )}
              </div>
            )}

          {/* <div className="d-flex justify-content-end">
            {!isEditingMarks && readonly !== "1" && (
              <div className="mb-3">
                <Button
                  variant="primary"
                  onClick={() => setIsEditingMarks(true)}
                  className="mb-2"
                >
                  Edit Marks
                </Button>
              </div>
            )}

            {isEditingMarks && (
              <div className="mb-3">
                <Button
                  variant="success"
                  onClick={handleSaveMarks}
                  className="mb-2 me-2"
                >
                  Save Marks
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setIsEditingMarks(false);
                    setUpdatedMarks({});
                    fetchEmployeeAppraisal();
                  }}
                  className="mb-2"
                >
                  Cancel
                </Button>
              </div>
            )}
          </div> */}

          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({
              handleSubmit,
              handleChange,
              values,
              touched,
              errors,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                {categoryMapvalues &&
                  Object.entries(categoryMapvalues)?.map(
                    ([categoryName, categoryOptions], index) => (
                      <div key={index}>
                        <h4>
                          {categoryOptions[0]?.categoryname
                            ? categoryOptions[0]?.categoryname.replace(
                                "&amp;",
                                "&"
                              )
                            : ""}
                        </h4>{" "}
                        {/* Display category name */}
                        <table
                          id={`example${index}`}
                          className="table table-striped w-100 mt-2"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Sub-Category Name</th>
                              <th>Question</th>
                              <th>Max Rating</th>
                              <th>Marks</th>
                              <th>Comments</th>
                            </tr>
                          </thead>
                          <tbody>
                            {categoryOptions?.map((option, qIndex) => {
                              // Get subcategory name - use from option if available, otherwise fetch from state
                              const displaySubcategoryName =
                                option.subcategoryname ||
                                (option.subcategory
                                  ? subcategoryNames[option.subcategory]
                                  : "");

                              return (
                                <tr key={qIndex}>
                                  <td>{qIndex + 1}</td>
                                  <td>{displaySubcategoryName}</td>
                                  <td>
                                    <Field
                                      as="textarea"
                                      disabled
                                      style={{ border: "none" }}
                                      rows={3}
                                      cols={30}
                                      readOnly={true}
                                      name={`questions${categoryName}[${qIndex}].question`}
                                      value={option?.text || option?.question}
                                    />
                                  </td>
                                  <td>
                                    {option.yesNo ? (
                                      <div>
                                        <Field
                                          as="select"
                                          name={`questions${categoryName}[${qIndex}].yesno`}
                                        >
                                          <option value="0">
                                            Select Yes/No
                                          </option>
                                          <option value="1">Yes</option>
                                          <option value="0">No</option>
                                        </Field>
                                        <Field
                                          type="hidden"
                                          name={`questions${categoryName}${qIndex}].rating`}
                                        />
                                      </div>
                                    ) : (
                                      ((
                                        <Field
                                          type="hidden"
                                          name={`questions${categoryName}[${qIndex}].yesno`}
                                        />
                                      ),
                                      (
                                        <Field
                                          type="text"
                                          className="w-25"
                                          disabled
                                          name={`questions${categoryName}[${qIndex}].rating`}
                                          value={option.rating}
                                        />
                                      ))
                                    )}
                                    <Field
                                      type="hidden"
                                      name={`questions${categoryName}[${qIndex}].category`}
                                      value={option.category}
                                    />
                                    <Field
                                      type="hidden"
                                      name={`questions${categoryName}[${qIndex}].ssubcategory`}
                                      value={option.subcategory}
                                    />
                                  </td>
                                  <td>
                                    <Field
                                      type="number"
                                      // className="w-50"
                                      disabled={
                                        !isEditingMarks || readonly === "1"
                                      }
                                      name={`questions${categoryName}[${qIndex}].marks`}
                                      value={getMarks(
                                        catSubcatMarks,
                                        categoryName,
                                        option.subcategory,
                                        option.text
                                      )}
                                      max={option.rating}
                                      min="0"
                                      onChange={(e) => {
                                        let newValue = e.target.value;

                                        // Convert to number
                                        newValue = parseInt(newValue, 10);
                                        if (isNaN(newValue)) newValue = 0;
                                        newValue = Math.max(newValue, 0);
                                        if (newValue > option.rating) {
                                          newValue = option.rating;
                                        }

                                        handleMarkChange(
                                          categoryName,
                                          option.subcategory,
                                          option.text || option.question,
                                          newValue
                                        );
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </td>
                                  <td>
                                    <Field
                                      as="textarea"
                                      disabled={
                                        !isEditingMarks || readonly === "1"
                                      }
                                      name={`questions${categoryName}[${qIndex}].comments`}
                                      cols={33}
                                      value={getComments(
                                        catSubcatMarks,
                                        categoryName,
                                        option.subcategory,
                                        option.text
                                      )}
                                      onChange={(e) => {
                                        handleCommentChange(
                                          categoryName,
                                          option.subcategory,
                                          option.text || option.question,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                            <td
                              colSpan="6"
                              className="text-end mx-1 text-dark fw-bold"
                            >
                              Section Total
                              <Field
                                type="number"
                                disabled
                                className="float-end mx-2"
                                name={`questions${categoryName}.total`}
                                value={categorymarks[categoryName]} // Calculated subtotal    //getCatSubTotal(categoryOptions,categoryName)
                                readOnly
                              />
                            </td>
                          </tbody>
                        </table>
                      </div>
                    )
                  )}
                <table width={"100%"}>
                  <tbody>
                    <tr>
                      <td
                        colspan="12"
                        className="text-end mx-1 text-dark fw-bold"
                      >
                        {" "}
                        Total Marks
                        <Field
                          type="number"
                          disabled
                          className="float-end mx-2 "
                          name="total"
                          value={totVal}
                          readOnly={true}
                        />{" "}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colspan="12"
                        className="text-start mx-1 text-dark fw-bold"
                      >
                        {/*
-------------------------KPI Appraisal Integration Table----------------------- */}
                        {isKpiWeightageIncluded &&
                        isKpiWeightageIncluded === true ? (
                          <>
                            <h5>KPI </h5>
                            <h6>KPI Weightage Value: {KPIWeightage}</h6>
                            <div className="bg-danger">
                              <ReactBootstrap.Table
                                striped
                                bordered
                                hover
                                size="sm"
                                className="bg-danger"
                              >
                                <thead className="text-center">
                                  <tr>
                                    <th>#</th>
                                    <th>KPI</th>
                                    <th nowrap>Start Date</th>
                                    <th>End Date</th>
                                    <th>Department</th>

                                    <th>Progress</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {posts.smartgoals.length === 0 ? (
                                    <tr>
                                      <td colSpan="8" className="text-center">
                                        No data
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                  {posts.smartgoals?.map((smartgoal, index) => (
                                    <React.Fragment key={index}>
                                      <tr className="w-100">
                                        <td>{index + 1}</td>
                                        <td>{smartgoal.title}</td>
                                        <td>
                                          {formatDate(smartgoal.startdate)}
                                        </td>
                                        <td>{formatDate(smartgoal.enddate)}</td>
                                        <td>{smartgoal.departmentname}</td>
                                        <td hidden>{smartgoal.assigneeids}</td>
                                        <td>
                                          <ProgressBar
                                            variant={getProgressColor(
                                              smartgoal.progress
                                            )}
                                            now={smartgoal.progress}
                                          />
                                        </td>
                                        <td className="col-1">
                                          <input
                                            type="number"
                                            max={KPIWeightage}
                                            value={kpiOptions[index]?.val}
                                            onChange={(e) =>
                                              handleKPIChange(e, smartgoal.id)
                                            }
                                            className="w-75"
                                            disabled
                                          ></input>
                                        </td>
                                        {/* Action buttons */}
                                      </tr>
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </ReactBootstrap.Table>
                            </div>

                            <h5>Sub KPI</h5>
                            <div className="">
                              <table className="w-100  bg-white">
                                <thead className="text-left">
                                  <tr className="tableheading">
                                    <th>#</th>
                                    <th>Sub KPI</th>
                                    <th>Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Progress</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {postsSub.subgoals?.map((subgoals, index) => (
                                    <tr className="text-left" key={index}>
                                      <td>{subgoals.id}</td>
                                      <td>{subgoals.title}</td>
                                      <td>{subgoals.description}</td>
                                      <td>{formatDate(subgoals.startdate)}</td>
                                      <td>{formatDate(subgoals.enddate)}</td>
                                      {/* <td>{smartgoal.designationid}</td>
                            <td>{smartgoal.assignees}</td> */}
                                      <td>
                                        <ProgressBar
                                          variant={getProgressColor(
                                            subgoals.progress
                                          )}
                                          now={subgoals.progress}
                                        />
                                      </td>
                                      <td className="col-1">
                                        <input
                                          value={
                                            subkpiOptions &&
                                            subkpiOptions[index]?.val
                                          }
                                          onChange={(e) =>
                                            handleSubKPIChange(e, subgoals.id)
                                          }
                                          type="number"
                                          max={KPIWeightage}
                                          className="w-75"
                                          disabled
                                        ></input>
                                      </td>
                                      {/* Action buttons */}
                                    </tr>
                                  ))}
                                  <tr>
                                    <td
                                      colspan="12"
                                      className="text-end mx-1 text-dark fw-bold"
                                    >
                                      KPI Total Marks
                                      <Field
                                        type="number"
                                        disabled
                                        className="float-end mx-2 "
                                        name="kpitotal"
                                        value={kpiTotal}
                                        readOnly={true}
                                      />{" "}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <br></br>
                          </>
                        ) : null}
                        <br />

                        <table width="100%">
                          <tr>
                            <td className="w-75 text-end   text-dark fw-bold">
                              <b>Overall Total Marks</b>
                            </td>
                            <td>
                              <Field
                                type="number"
                                disabled
                                className="float-end mx-2 "
                                name="appraisalTotal"
                                value={parseInt(kpiTotal) + parseInt(totVal)}
                                readOnly={true}
                              />
                            </td>
                          </tr>
                        </table>

                        <div>
                          <hr></hr>
                          <h5> Overall Rating : {rating} </h5>
                        </div>
                        <hr></hr>

                        <h4>Personal Development Plan</h4>
                        <p>
                          Assessor to comment on any training, educational
                          requirement that would benefit the employee
                        </p>
                        <textarea
                          disabled={!isEditingMarks}
                          rows="5"
                          cols="110"
                          value={trainingComment}
                          onChange={handleTextareaChange}
                          className="w-100"
                        ></textarea>
                      </td>{" "}
                    </tr>
                    <tr>
                      <td
                        colspan="12"
                        className="text-start  text-dark fw-bold"
                      >
                        <h5>ASSESSOR : </h5>
                        <div>
                          {assessorDate === "" || assessorDate === null ? (
                            "Assessor not reviewed"
                          ) : (
                            <React.Fragment>
                              Assessor Name: &nbsp;&nbsp;&nbsp;&nbsp;
                              {hassupervisor === "Yes"
                                ? supervisorName
                                : managerName}
                              <br></br>
                              Assessment Date:&nbsp; {formatDate(assessorDate)}
                              <br></br>
                            </React.Fragment>
                          )}
                        </div>
                        <table className="w-100">
                          <tr className="w-100">
                            <td> </td>
                            <td></td> <td> </td>
                            <td></td>
                          </tr>
                        </table>
                        <textarea
                          disabled={!isEditingMarks}
                          rows="5"
                          className="w-100"
                          cols="110"
                          value={assessorComments ?? managerComments}
                          onChange={(e) => setAssessorComments(e.target.value)}
                        ></textarea>
                        <h5>Declaration</h5>
                        <input
                          type="checkbox"
                          checked={approval && approval !== null}
                        />{" "}
                        &nbsp; Confirm
                        <br /> I hereby declare that the evaluation is to best
                        of my knowledge, and reflects the fact about employee’s
                        performance and I take responsibility for any misleading
                        information
                        <br />
                        <br />
                      </td>
                    </tr>

                    <tr>
                      <td colspan="12">
                        <h4>APPRAISEE SECTION</h4>
                        <React.Fragment>
                          <b>
                            {employeeApprovalDate === "" ||
                            employeeApprovalDate === null ? (
                              "Appraisee not reviewed"
                            ) : (
                              <div>
                                <b>
                                  Appraisee Name: &nbsp;&nbsp;{" "}
                                  {employee?.FirstName} {employee?.LastName}
                                </b>
                                <br></br>
                                <b>
                                  {" "}
                                  Reviewed Date: &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                  {formatDate(employeeApprovalDate)}{" "}
                                </b>
                              </div>
                            )}
                          </b>
                        </React.Fragment>
                        <br></br>
                        <textarea
                          rows="5"
                          cols="110"
                          disabled={
                            (approval && employeeApprovalDate === null) ||
                            approval === "Approver Approved" ||
                            approval === "HR Approved" ||
                            approval === "Manager Submitted" ||
                            managerComments ||
                            assessorComments
                          }
                          value={
                            employeeComments
                              ? employeeComments
                              : generalComments
                          }
                          className="w-100"
                          onChange={(e) => handleHEmployeeomments(e)}
                        >
                          {employeeComments}
                        </textarea>
                        <h5>Declaration</h5>
                        <input
                          type="checkbox"
                          checked={approval && approval !== null}
                        />{" "}
                        &nbsp; Confirm
                        <br /> I hereby declare that the evaluation is best of
                        my knowledge, and reflects the fact about my performance
                        and I accept it.
                        {hassupervisor && hassupervisor === "Yes" && (
                          <React.Fragment>
                            <br />
                            <br />
                            <br />
                            <h4>APPROVER SECTION</h4>
                            <React.Fragment>
                              <b>
                                {approversDate === "" ||
                                approversDate === null ? (
                                  "Approver not reviewed"
                                ) : (
                                  <div>
                                    <b>
                                      Approver Name: &nbsp;&nbsp;{" "}
                                      {employee.ManagerFirstName}{" "}
                                      {employee.ManagerLastName}
                                    </b>
                                    <br></br>
                                    <b>
                                      {" "}
                                      Reviewed Date: &nbsp;&nbsp;&nbsp;&nbsp;
                                      &nbsp;{formatDate(approversDate)}{" "}
                                    </b>
                                  </div>
                                )}
                              </b>
                            </React.Fragment>
                            <br></br>
                            <textarea
                              rows="5"
                              cols="110"
                              // disabled={(approval && (approversDate===null) || (approval==="Approver Approved") || (approval === "HR Approved" || approval === "Manager Submitted" || (hassupervisor === "Yes" && approval === "Employee Accepted")))}
                              disabled={approversDate}
                              value={approverComments || approversComments}
                              className="w-100"
                              onChange={(e) => handleApproveromments(e)}
                            >
                              {approverComments}
                            </textarea>
                            <br />
                            <h5>Declaration</h5>
                            <input
                              type="checkbox"
                              checked={approval && approval !== null}
                            />{" "}
                            &nbsp; Confirm
                            <br /> I hereby declare that the evaluation is best
                            of my knowledge, and reflects the fact about my
                            performance and I accept it.
                          </React.Fragment>
                        )}
                        <div className="lg-12">
                          <Button
                            disabled={
                              (approval && readonly === "1") ||
                              role === "ROLE_SUPERVISOR" ||
                              (role === "ROLE_MANAGER" &&
                                approval !== "Employee Accepted") ||
                              approval === "HR Approved" ||
                              approval === "Employee Appealed" ||
                              approval === "Manager Submitted" ||
                              approval === "Approver Approved" ||
                              approval === "Manager Approved" ||
                              approval === "Approver Rejected" ||
                              (appeal && appeal !== "Appealed")
                            }
                            className="border-0 mt-2 p-3 btn-#8d3523 "
                            onClick={handleApproverSubmit}
                          >
                            I Approve This Appraisal
                          </Button>

                          <Button
                            disabled={
                              (approval && readonly === "1") ||
                              role === "ROLE_SUPERVISOR" ||
                              approval === "HR Approved" ||
                              approval === "Employee Appealed" ||
                              approval === "Manager Submitted" ||
                              approval === "Approver Approved" ||
                              approval === "Manager Approved" ||
                              approval === "Approver Rejected" ||
                              (appeal && appeal !== "Appealed")
                            }
                            className="ml-2 border-0 mt-2 p-3 bg-danger"
                            onClick={handleApproverRejectSubmit}
                          >
                            I Reject This Appraisal
                          </Button>
                        </div>
                      </td>
                    </tr>
                    {approvalDate ? (
                      <div>
                        <label htmlFor="approvalDate">Status Date:</label>
                        <input
                          type="text"
                          id="approvalDate"
                          value={approvalDate}
                          className=""
                          readOnly // to make it read-only
                        />

                        <div>
                          {" "}
                          <label> Status: {approvalStatus}</label>
                        </div>
                      </div>
                    ) : null}
                    {appeallDate && approval !== "Manager Submitted" ? (
                      <div>
                        <label htmlFor="applealdate f18">
                          Appeal Requested Date:
                        </label>
                        <input
                          type="text"
                          id="approvalDate"
                          value={appeallDate}
                          className="w-75 p-75 border-0 fw-bold f6"
                          readOnly // to make it read-only
                        />
                        {appealStatus && (
                          <label>
                            <b>Appeal Status:</b> {appealStatus}{" "}
                          </label>
                        )}
                      </div>
                    ) : null}

                    {showHRApproval ? (
                      <tr>
                        <td colspan="12">
                          {" "}
                          <div className="col-12">
                            <h4>HR Approval:</h4>
                            <textarea
                              rows="5"
                              cols="110"
                              disabled={
                                hrApproved ||
                                approvalStatus === "Appeal Committee Approved"
                              }
                              className="border-1 mt-2 p-3 btn-#8d3523 "
                              value={hrComments}
                              onChange={(e) => handleHRComments(e)}
                            ></textarea>
                            <br />
                            <h5>Declaration</h5>
                            <input
                              type="checkbox"
                              checked={approval && approval !== null}
                            />{" "}
                            &nbsp; Confirm
                            <br /> I hearby declare that is to the best of my
                            knowledge, and reflects the fact about employees
                            performance and I take responsibility for any
                            misleading information.
                          </div>
                          <Button
                            disabled={
                              hrApproved ||
                              approvalStatus === "Appeal Committee Approved"
                            }
                            className="border-0 mt-2 p-3 btn-#8d3523 "
                            onClick={handleHRApproval}
                          >
                            Approve This Appraisal
                          </Button>{" "}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </form>
            )}
          </Formik>

          <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to submit this appraisal?
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={handleConfirm}>
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
          <Modal show={isModal2Open} onHide={() => setIsModal2Open(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Appeal Appraisal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want Appeal Appraisal?
              <textarea
                name="appealcomments"
                rows={5}
                cols={60}
                onChange={handleAppealChange}
              ></textarea>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={handleConfirmAppeal}>
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setIsModal2Open(false)}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
          <div>
            <ToastContainer position="bottom-end" className="p-3">
              <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                className="bg-success text-white"
              >
                <Toast.Header>
                  <span className="me-2">✔️</span> {/* Unicode tick mark */}
                  <strong className="me-auto">Notification</strong>
                </Toast.Header>
                <Toast.Body>Success!, data updated successfully!</Toast.Body>
              </Toast>
            </ToastContainer>
          </div>
        </BasicCard>
      </>
    );
  else {
    return (
      <>
        <Dummylayout />
        <BasicCard>
          <div className="container topmiller ">
            <div className="row ">
              <h4>Appraisal of:</h4>
              <br />
              <br />
              <div className="col-4 ">
                <span className="vfont fs-">Name</span>
                <p className="bfont fs-5 fw-bold">
                  {employee.FirstName} {employee.LastName}
                </p>
                <span className="vfont fs">Current Position</span>
                <p className="bfont fs-5 fw-bold">{employee.designation}</p>
              </div>
              <div className="col-4 ">
                <span className="vfont fs">Employee ID</span>
                <p className="bfont fs-5 fw-bold"> {employee.employeeid}</p>
                <span className="vfont fs">Grade</span>
                <p className="bfont fs-5 fw-bold">{employee.gradename}</p>
              </div>
              <div className="col-lg-4 ">
                <img
                  className="float-end mx-5"
                  width="110"
                  alt=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                />
              </div>
            </div>
            <hr></hr>
            <br></br>
            <br></br>
            <h5>
              Your Manager has not completed your appraisal. Please contact your
              manager
            </h5>
            <br></br>
            <br></br>
            <hr></hr>
          </div>
        </BasicCard>
      </>
    );
  }
}

export default ViewEmployeeAppraisal;
